/**系统级广播工具，用于异步反向通知基础层，模拟订阅者模式*/
import { msSessionStorage } from '@common/utils/cache';
import { getCookie } from '@common/stores/cookie';

// 运行所有依赖token的事件
export const runDependOnToken = new CustomEvent('runDependOnToken', {
  detail: {
    token: getCookie('vtoken'),
  },
});

// 运行所有依赖appkey事件
export const runDependOnAppKey = new CustomEvent('runDependOnAppKey', {
  detail: {
    appKey: msSessionStorage.get('PUBLIC_APPKEY'),
  },
});

// 运行所有依赖userId的事件
export const runDependOnUserId = new CustomEvent('runDependOnUserId', {
  detail: {
    userId: msSessionStorage.get('PUBLIC_USERID'),
  },
});

// 切换已登录用户（并非合理方案，应在登录节点做页面所有缓存重置）
// export const changeLoginer = new CustomEvent('changeLoginer');
